<template>
  <div class="default-tooltip">
    <span ref="linkRef" class="tooltip-value" v-html="highlight()" />
  </div>
</template>

<script>
import { highlightSubstring } from "@/utils/highlightSubstring";
import { exceptionSelectionMixin } from "@/mixins/exceptionSelectionMixin";

export default {
  name: "ProposalNameTooltip",
  mixins: [exceptionSelectionMixin],
  props: {
    value: Object,
    row: Object,
    column: Object,
  },
  methods: {
    highlight() {
      return highlightSubstring(
        this.value.proposalName,
        this.currentTab?.searchCriteria?.keyWords || "",
      );
    },
  },
};
</script>

<style scoped lang="less">
.default-tooltip {
  .tooltip-value {
    cursor: text;
    user-select: text;

    &::selection {
      background-color: #4766cb;
      color: #fff;
    }
  }
}
</style>
